
/** @format */

import React, { type Ref } from 'react'

const cx = (...classes: any[]) => classes.filter(Boolean).join(' ')

const PanelWrapBase = ({ width, className, style, children, ref, ...props }: any & { ref?: Ref<any> }) => (
  <div
    ref={ref}
    className={cx('box-border [&_.files-box]:mb-2.5', className)}
    style={{
      width: width ?? 'inherit',
      ...style,
    }}
    {...props}
  >
    {children}
  </div>
)
PanelWrapBase.displayName = 'PanelWrapBase'

const PanelWrapTable = ({ width, className, style, children, ref, ...props }: any & { ref?: Ref<any> }) => (
  <div
    ref={ref}
    className={cx(
      'flex items-center justify-between px-6 py-6 border-b border-[#E9E9E9]',
      '[&_.name-box]:flex-1 [&_.name-box]:min-w-0 [&_.name-box]:flex [&_.name-box]:flex-col [&_.name-box]:gap-2',
      '[&_.author-box]:w-[150px] [&_.author-box]:shrink-0 [&_.author-box]:flex [&_.author-box]:flex-col [&_.author-box]:gap-2',
      '[&_.date-box]:w-[180px] [&_.date-box]:shrink-0 [&_.date-box]:flex [&_.date-box]:flex-col [&_.date-box]:gap-2',
      '[&_.action-box]:w-[60px] [&_.action-box]:shrink-0 [&_.action-box]:flex [&_.action-box]:items-center [&_.action-box]:gap-2 [&_.action-box]:justify-end',
      '[&_.key]:text-xs [&_.key]:text-[#999] [&_.key]:font-normal',
      '[&_.value]:text-[13px] [&_.value]:font-semibold [&_.value]:text-[#212121] [&_.value]:overflow-hidden [&_.value]:text-left [&_.value]:whitespace-nowrap [&_.value]:text-ellipsis',
      '[&_.name-box_.value]:text-[#0078D4] [&_.name-box_.value]:text-xs [&_.name-box_.value]:font-normal',
      className
    )}
    style={style}
    {...props}
  >
    {children}
  </div>
)
PanelWrapTable.displayName = 'PanelWrapTable'

export const PanelWrap = Object.assign(PanelWrapBase, {
  Table: PanelWrapTable,
})
